/**
 * "Open repair order" dispatch warning.
 *
 * The sibling of `openTroubleTicketCheck` and built the same way: the backend's
 * `attach_open_repair_orders` (app/utils/open_repair_orders.py) owns the
 * definition and produces `openRoCount`; this module only renders it.
 *
 * Two things that definition gets right and a frontend reimplementation would
 * not, which is the reason it lives server-side:
 *
 *  - Open is the named set OPEN/PENDING/DEFERRED/DISPATCHED, not "anything that
 *    isn't finished". `repairorder.orderstatus` holds legacy values beside the
 *    current ones, and 'COMPLETE' is a *different string* from 'Completed' — an
 *    exclusion check would call thousands of finished repairs open.
 *  - A repair order reaches an order by pronumber, container OR chassis. Repairs
 *    are filed against equipment, so 551 of 575 open ones carry pronumber = 0;
 *    matching on the pro alone would warn on 20 live orders instead of 745
 *    (prod 2026-09-30).
 *
 * Order-level, like the trouble-ticket warning: the repair is on the box or the
 * chassis the whole move is riding, so there is no leg to scope it to.
 */

/**
 * The dispatch-warning line for an order's open repair-order count, or `null`
 * when there is nothing to warn about.
 *
 * `undefined` means the surface's endpoint does not run the enricher — unknown,
 * not zero — so an unwired surface stays silent rather than warning on every row.
 */
export function openRepairOrderWarning(openRoCount?: number): string | null {
  if (typeof openRoCount !== 'number' || openRoCount <= 0) return null;
  return openRoCount === 1
    ? 'Warning: 1 open Repair Order'
    : `Warning: ${openRoCount} open Repair Orders`;
}
